import React, {Component} from 'react'
import EmptySharedImg from "../../assets/images/empty-shared.png";
import "./EmptyShared.css";

export class EmptyShared extends Component {
    render(){
        return (
            <div
                className='empty-shared-wrapper'
            >
                <p
                    className='empty-shared-p'
                >
                    Estos son tus documentos compartidos<br />es como un buzón de entrada
                </p>
                <img 
                    className='empty-shared-img'
                    src={EmptySharedImg} 
                    alt="empty" 
                />
            </div>
        )
    }
}

export default EmptyShared;